__turbopack_context__.v({
  "container": "TrustPilotTwoLinesWidget-module__h4F5QG__container",
  "noMargin": "TrustPilotTwoLinesWidget-module__h4F5QG__noMargin",
  "stats": "TrustPilotTwoLinesWidget-module__h4F5QG__stats",
});
